import { CommunicationChannel, CustomerCommunicationListItem } from "./types";

type Translate = (key: string) => string;

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export const getTrackingColumnLabel = (
  channel: CommunicationChannel,
  tr: Translate
): string => (channel === "email" ? tr("Read Receipt") : tr("Delivery"));

export const formatSmsDeliveryStatus = (
  status: string | null,
  tr: Translate
): string => {
  if (!status) return "—";

  const normalized = status.toLowerCase();
  if (normalized === "queued") return tr("deliveryQueued");
  if (normalized === "delivered") return tr("deliveryDelivered");
  if (["accepted", "sending", "sent"].includes(normalized)) {
    return tr("deliverySentToCarrier");
  }
  if (["undelivered", "failed"].includes(normalized)) {
    return tr("deliveryFailed");
  }

  return status.charAt(0).toUpperCase() + status.slice(1);
};

export const formatEmailTracking = (
  row: Pick<
    CustomerCommunicationListItem,
    "readAt" | "openCount" | "readReceiptApplicable"
  >,
  tr: Translate
): string => {
  if (!row.readReceiptApplicable) return "—";

  if (row.readAt) {
    const opened = formatDate(row.readAt);
    if (row.openCount > 1) {
      return `${opened} · ${row.openCount}×`;
    }
    return opened;
  }

  // Opens are detected through a tracking image, so "not opened" was never a
  // fact: image-blocking clients register nothing and a reply is not an open.
  // The label says what is actually known (ESERV2-1496).
  return tr("No open detected");
};

export const formatTrackingValue = (
  row: CustomerCommunicationListItem,
  tr: Translate
): string => {
  if (row.channel === "email" && row.readReceiptApplicable) {
    return formatEmailTracking(row, tr);
  }

  if (row.channel === "sms") {
    return formatSmsDeliveryStatus(row.deliveryStatus, tr);
  }

  return "—";
};
